import getClonedObject from "@/helper/getClonedObject";

export default function(state, settings, key, defaultHeader) {
	let obj = [];

	if (Array.isArray(settings) && settings.length > 0) {
		obj = settings;
	} else if (
		settings &&
			Array.isArray(settings.setting) &&
			settings.setting.length > 0
	) {
		obj = settings.setting;
	} else {
		obj = defaultHeader;
	}

	state.settingsDefault = getClonedObject(obj);
	state.settings = getClonedObject(obj);
	state.settingsHeaders = [];

	obj.forEach(item => {
		if (item.settings) {
			state.settingsHeaders.push(item);
		}
	});
}
